import React, { createContext, useContext, useEffect, useState } from "react";

const VideoContext = createContext();

export const useVideo = () => useContext(VideoContext);

export const VideoProvider = ({ children }) => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("videos")) || [];
    setVideos(data);
  }, []);

  const addVideo = (video) => {
    const newVideo = {
      ...video,
      id: Date.now(),
    };

    const updated = [...videos, newVideo];
    setVideos(updated);
    localStorage.setItem("videos", JSON.stringify(updated));
  };

  const updateVideo = (updatedVideo) => {
    const updated = videos.map((video) =>
      video.id === updatedVideo.id ? updatedVideo : video
    );

    setVideos(updated);
    localStorage.setItem("videos", JSON.stringify(updated));
  };

  const deleteVideo = (id) => {
    const updated = videos.filter((video) => video.id !== id);
    setVideos(updated);
    localStorage.setItem("videos", JSON.stringify(updated));
  };

  return (
    <VideoContext.Provider
      value={{ videos, addVideo, updateVideo, deleteVideo }}
    >
      {children}
    </VideoContext.Provider>
  );
};